module.exports = __webpack_public_path__ + "static/img/1.cf3a1a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/1.png
// module id = Z926
// module chunks = 0